import React from 'react'
import { withIcon } from '../../withIcon'

function EllipsisHorizontalIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M5 11.625C4.79289 11.625 4.625 11.7929 4.625 12C4.625 12.2071 4.79289 12.375 5 12.375C5.20711 12.375 5.375 12.2071 5.375 12C5.375 11.7929 5.20711 11.625 5 11.625ZM3.375 12C3.375 11.1025 4.10254 10.375 5 10.375C5.89746 10.375 6.625 11.1025 6.625 12C6.625 12.8975 5.89746 13.625 5 13.625C4.10254 13.625 3.375 12.8975 3.375 12ZM12 11.625C11.7929 11.625 11.625 11.7929 11.625 12C11.625 12.2071 11.7929 12.375 12 12.375C12.2071 12.375 12.375 12.2071 12.375 12C12.375 11.7929 12.2071 11.625 12 11.625ZM10.375 12C10.375 11.1025 11.1025 10.375 12 10.375C12.8975 10.375 13.625 11.1025 13.625 12C13.625 12.8975 12.8975 13.625 12 13.625C11.1025 13.625 10.375 12.8975 10.375 12ZM19 11.625C18.7929 11.625 18.625 11.7929 18.625 12C18.625 12.2071 18.7929 12.375 19 12.375C19.2071 12.375 19.375 12.2071 19.375 12C19.375 11.7929 19.2071 11.625 19 11.625ZM17.375 12C17.375 11.1025 18.1025 10.375 19 10.375C19.8975 10.375 20.625 11.1025 20.625 12C20.625 12.8975 19.8975 13.625 19 13.625C18.1025 13.625 17.375 12.8975 17.375 12Z" fill={color}/>
    </svg>
  )
}

export default withIcon(EllipsisHorizontalIcon)
